


























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Mixins, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import Notification from '@part/notification/Notification.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        Notification
    },

    computed: {
        unreadTitle() {
            return `Ongelezen (${ this.unreadTotel  })`;
        },

        readTitle() {
            return `Gelezen (${ this.readTotal })`;
        },

        unreadTotel() {
            return Object.keys(this.stateNotifications.unread).length;
        },

        readTotal() {
            return Object.keys(this.stateNotifications.read).length;
        }
    },

    methods: {
        markAllAsRead() {
            this.$store.dispatch('notification/setRead');
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Notifications extends Vue {}

